import { mapActions, mapState } from "vuex";
import StatisticsLine from "../chart-types/statistics-line";
import { AlertTypes } from "../../../constants/alert_types";
import i18n from "../../../plugins/i18n";

export default {
  name: "HealthChart",
  props: {},
  components: { StatisticsLine },
  data: () => ({
    categories: {
      [AlertTypes.IncreasedActivity]: { name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.IncreasedActivity}`) },
      [AlertTypes.DecreasedActivity]: { name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.DecreasedActivity}`) },
      [AlertTypes.LowWaterIntake]: { name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.LowWaterIntake}`) },
      [AlertTypes.HighTemp]: { name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.HighTemp}`) },
      [AlertTypes.LowTemp]: { name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.LowTemp}`) },
    }
  }),
  computed: {
    ...mapState({
      /**
       * Gather health chart data from state and format it to display
       * @param {object} state The main state object
       */
      chartData(state) {
        const healthData = state.chart.health;

        // Sum the dataset, this will be the 100%
        const sumOfChart = Math.max(
          ...Object.values(healthData)
        );

        // Format data
        const formattedData = Object.keys(this.categories).map(category => ({
          data: healthData[category],
          name: this.categories[category].name,
          key: category.replace(/\s/g, ''),
          // calculate percentage
          percentage:
            sumOfChart > 0 ? (healthData[category] / sumOfChart) * 100 : 0
        }));

        // Sort by data, so first item will be the highest
        const sortedData = formattedData.sort((a, b) => {
          return b.percentage - a.percentage;
        });
        return sortedData;
      },
      isFetching: state => state.chart.isFetching
    })
  },
  methods: {
    ...mapActions("chart", {
      getChart: "getHealthChart",
      clearChart: "clearChart"
    })
  },
  mounted() {
    this.getChart();
  },
  destroyed() {
    this.clearChart();
  }
};



// WEBPACK FOOTER //
// ./src/components/_charts/health/health-chart.js